import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import path from 'path';
import Fuse from 'fuse.js'; // A lightweight fuzzy-search module
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { PermissionModule } from '@/store/modules/permission';
import i18n from '@/lang'; // Internationalization
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.search = '';
    this.show = false;
    this.options = [];
    this.searchPool = [];
  }
  get routes() {
    return PermissionModule.routes;
  }
  get lang() {
    return AppModule.language;
  }
  onLangChange() {
    this.searchPool = this.generateRoutes(this.routes);
  }
  onRoutesChange() {
    this.searchPool = this.generateRoutes(this.routes);
  }
  onSearchPoolChange(value) {
    this.initFuse(value);
  }
  onShowChange(value) {
    if (value) {
      document.body.addEventListener('click', this.close);
    } else {
      document.body.removeEventListener('click', this.close);
    }
  }
  mounted() {
    this.searchPool = this.generateRoutes(this.routes);
  }
  click() {
    this.show = !this.show;
    if (this.show) {
      this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.focus();
    }
  }
  close() {
    this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.blur();
    this.options = [];
    this.show = false;
  }
  change(route) {
    this.$router.push(route.path);
    this.search = '';
    this.options = [];
    this.$nextTick(() => {
      this.show = false;
    });
  }
  initFuse(list) {
    this.fuse = new Fuse(list, {
      shouldSort: true,
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [{
        name: 'title',
        weight: 0.7
      }, {
        name: 'path',
        weight: 0.3
      }]
    });
  }
  // Filter out the routes that can be displayed in the sidebar
  // And generate the internationalized title
  generateRoutes(routes, basePath = '/', prefixTitle = []) {
    let res = [];
    for (const router of routes) {
      // skip hidden router
      if (router.meta && router.meta.hidden) {
        continue;
      }
      const data = {
        path: path.resolve(basePath, router.path),
        meta: {
          title: [...prefixTitle]
        }
      };
      if (router.meta && router.meta.title) {
        // generate internationalized title
        const i18ntitle = i18n.t(`route.${router.meta.title}`).toString();
        data.meta.title = [...data.meta.title, i18ntitle];
        if (router.redirect !== 'noRedirect') {
          // only push the routes with title
          // special case: need to exclude parent router without redirect
          res.push(data);
        }
      }
      // recursive child routes
      if (router.children) {
        const tempRoutes = this.generateRoutes(router.children, data.path, data.meta.title);
        if (tempRoutes.length >= 1) {
          res = [...res, ...tempRoutes];
        }
      }
    }
    return res;
  }
  querySearch(query) {
    if (query !== '') {
      if (this.fuse) {
        this.options = this.fuse.search(query);
      }
    } else {
      this.options = [];
    }
  }
};
__decorate([Watch('lang')], default_1.prototype, "onLangChange", null);
__decorate([Watch('routes')], default_1.prototype, "onRoutesChange", null);
__decorate([Watch('searchPool')], default_1.prototype, "onSearchPoolChange", null);
__decorate([Watch('show')], default_1.prototype, "onShowChange", null);
default_1 = __decorate([Component({
  name: 'HeaderSearch'
})], default_1);
export default default_1;